import { Icon } from "react-bulma-components";
import { Trans, useTranslation } from "react-i18next";
import { deleteUserAccount } from "../../../../models/user";
import { useEntitlements } from "../../../../models/entitlements";
import { fbAuth } from "../../../../firebase";
import { useAuthContext } from "../../../auth/AuthProvider";
import { ModalProps } from "../../ModalManager";
import { ConfirmModal } from "../ConfirmModal";
import { SUPPORT_MAILTO } from "../../../../util/supportUrl";

export type ConfirmDeleteAccountModalProps = ModalProps;

export function ConfirmDeleteAccountModal({ ...props }: ConfirmDeleteAccountModalProps) {
  const { t } = useTranslation();
  const [userUid] = useAuthContext();
  const [entitlements] = useEntitlements(userUid ?? undefined);

  const isPro = entitlements?.pro?.active === true;
  const isSupporter = entitlements?.supporter?.active === true;

  const handleOnClick = async () => {
    const success = await deleteUserAccount();
    if (success) {
      await fbAuth.signOut();
      window.location.href = "/";
    }
    props.closeModal();
  }

  const description = (
    <>
      <p>{t("modal.deleteAccount.description")}</p>
      {isPro && (
        <>
          <p style={{ marginTop: "0.75rem" }}>{t("modal.deleteAccount.proWarning")}</p>
          <p style={{ marginTop: "0.5rem" }}>
            <Trans i18nKey="modal.deleteAccount.downgradeHint" components={{ link: <a href={SUPPORT_MAILTO} /> }} />
          </p>
        </>
      )}
      {isSupporter && (
        <p style={{ marginTop: "0.5rem" }}>{t("modal.deleteAccount.supporterWarning")}</p>
      )}
    </>
  );

  return (
    <ConfirmModal
      title={t("warning")}
      subtitle={t("modal.deleteAccount.subtitle")}
      description={description}
      closeModal={props.closeModal}
      onConfirm={handleOnClick}
      confirmButtonText={t("modal.deleteAccount.confirm")}
    >
      <Icon color="danger" size="medium">
        <i className="icon-trash is-large" aria-hidden="true"></i>
      </Icon>
    </ConfirmModal>
  )
}
